import { AI_PLAYGROUND_CONSTANTS } from "../AIPlayground.constants";

export { buildHtmlDocument } from "./documentGeneration";
export { generateTipKey } from "./errorDisplay";
export {
  cleanShareParamsFromUrl,
  copyToClipboard,
  generateShortShareUrl,
  getShareIdFromUrl,
  type ShareData
} from "./shareUrl";

// Re-export constants for backward compatibility
export const DEFAULT_ERROR_MESSAGE = AI_PLAYGROUND_CONSTANTS.MESSAGES.DEFAULT_ERROR_MESSAGE;
export const ERROR_COLORS = AI_PLAYGROUND_CONSTANTS.ERROR_COLORS;
export const TROUBLESHOOTING_TIPS = AI_PLAYGROUND_CONSTANTS.TROUBLESHOOTING_TIPS;
